import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { content } from '../data/content';
import { PRODUCT, formatPrice } from '../data/product';
import { orderPath } from './ui/Ui';

/** صور المنتج الاحترافية — كلها بنسبة 1:1، فالإطار مربّع ليعرضها كاملة بلا قص */
const GALLERY = [
  { src: '/p1.jpg', alt: 'مكوى البخار MATRXS ومميزاته: بخار قوي، مناسب لجميع الأقمشة، حامل متعدد الوظائف' },
  { src: '/p2.jpg', alt: 'قميص قبل وبعد استخدام مكوى البخار MATRXS' },
  { src: '/p3.jpg', alt: 'مكوى البخار العامودي MATRXS داخل غرفة الملابس' },
];

const SLIDE_INTERVAL = 4500;
const SWIPE_THRESHOLD = 40;

/**
 * الشاشة الأولى تحمل قرار الشراء كاملاً.
 *
 * الترتيب يتبع تسلسل صفحات المنتجات المتعارف عليه:
 *   العنوان ← الوصف ← عدد الزبائن ← السعر ← الأزرار ← المواصفات.
 * عدد الزبائن قبل السعر عمداً: الدليل الاجتماعي يبرّر الرقم قبل أن يراه العميل.
 *
 * سطح المكتب: ارتفاع الشاشة كاملاً، النص يمين والصورة يسار، وكلاهما موسّط
 *   رأسياً — بلا الفراغ الذي كان ينشأ من تمدّد صفوف الشبكة خلف الصورة.
 * الجوال: الصورة أولاً ثم النص، لأن الصورة هي ما يوقف التمرير.
 */
export default function Hero() {
  const [active, setActive] = useState(0);
  const touchStartX = useRef(null);

  const saving = PRODUCT.oldPrice - PRODUCT.price;
  const go = (index) => setActive((index + GALLERY.length) % GALLERY.length);

  // التبديل التلقائي، ويُعاد ضبط المؤقّت كلما تنقّل المستخدم يدوياً
  useEffect(() => {
    const id = setInterval(() => setActive((prev) => (prev + 1) % GALLERY.length), SLIDE_INTERVAL);
    return () => clearInterval(id);
  }, [active]);

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (touchStartX.current === null) return;
    const delta = e.changedTouches[0].clientX - touchStartX.current;
    if (Math.abs(delta) > SWIPE_THRESHOLD) go(delta < 0 ? active + 1 : active - 1);
    touchStartX.current = null;
  };

  return (
    <section
      id="home"
      className="relative w-full bg-white overflow-hidden pt-4 pb-10 md:pt-10 md:pb-20 lg:py-0 lg:min-h-[calc(100vh-76px)] lg:flex lg:items-center"
    >
      {/* توهّج خفيف بلون البراند يعطي عمقاً للشاشة الأولى بدل الأبيض المسطّح */}
      <div className="absolute -top-32 start-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-z-red/[0.06] blur-3xl pointer-events-none" />

      <div className="container mx-auto max-w-7xl relative w-full">
        <div className="grid gap-4 md:gap-6 lg:grid-cols-2 lg:gap-x-12 lg:gap-y-5">
          {/* ===== سلايدر المنتج ===== */}
          {/* max-w مرتبط بارتفاع الشاشة حتى لا يتجاوز المربّع حدود الشاشة الأولى.
              ms-auto على سطح المكتب يلصق الصورة بحافة المحتوى اليسرى فتحاذي
              الهيدر تماماً، بدل أن تطفو في منتصف عمودها ويختلّ توازن الصفحة. */}
          <div className="w-full max-w-[320px] sm:max-w-sm lg:max-w-[min(40rem,68vh)] mx-auto lg:ms-auto lg:me-0 lg:col-start-2 lg:row-start-1 lg:row-span-2 lg:self-center">
            <div
              onTouchStart={onTouchStart}
              onTouchEnd={onTouchEnd}
              className="relative rounded-3xl bg-z-light border border-gray-200 shadow-sm overflow-hidden aspect-square select-none"
            >
              <span className="absolute top-3 end-3 md:top-4 md:end-4 bg-z-red text-white px-4 py-1.5 md:px-5 md:py-2 font-bold shadow-lg z-20 rounded-full text-xs md:text-sm">
                {content.discount}
              </span>

              {GALLERY.map((item, i) => (
                <img
                  key={item.src}
                  src={item.src}
                  alt={item.alt}
                  /* الأبعاد الصريحة تحجز مساحة الصورة قبل تحميلها فلا يقفز
                     التخطيط، وأولوية عالية للأولى لأنها عنصر LCP */
                  width="1100"
                  height="1100"
                  loading={i === 0 ? 'eager' : 'lazy'}
                  fetchPriority={i === 0 ? 'high' : 'low'}
                  decoding="async"
                  draggable="false"
                  className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                    i === active ? 'opacity-100' : 'opacity-0'
                  }`}
                />
              ))}

              <button
                onClick={() => go(active - 1)}
                aria-label="الصورة السابقة"
                className="absolute z-20 top-1/2 -translate-y-1/2 start-3 w-9 h-9 rounded-full bg-white/90 border border-gray-200 text-z-navy hover:bg-z-red hover:text-white hover:border-z-red transition flex items-center justify-center shadow-sm"
              >
                <i className="fa-solid fa-chevron-right text-sm" />
              </button>
              <button
                onClick={() => go(active + 1)}
                aria-label="الصورة التالية"
                className="absolute z-20 top-1/2 -translate-y-1/2 end-3 w-9 h-9 rounded-full bg-white/90 border border-gray-200 text-z-navy hover:bg-z-red hover:text-white hover:border-z-red transition flex items-center justify-center shadow-sm"
              >
                <i className="fa-solid fa-chevron-left text-sm" />
              </button>
            </div>

          </div>

          {/* ===== العنوان والسعر والأزرار ===== */}
          {/* self-end على سطح المكتب يلصق هذا الجزء بالجزء الذي تحته فيختفي الفراغ */}
          <div className="text-center lg:text-start lg:col-start-1 lg:row-start-1 lg:self-end">
            <h1 className="text-[26px] sm:text-3xl md:text-4xl xl:text-5xl font-bold leading-[1.3] text-z-navy mb-2">
              {content.heroTitle} <span className="text-z-red">{content.heroTitleHighlight}</span>
            </h1>

            <p className="text-sm md:text-lg text-z-gray max-w-xl mx-auto lg:mx-0 leading-relaxed mb-4">
              {content.heroSubtitle}
            </p>

            {/* التقييم وعدد المراجعات حُذفا: رقمان لا سجلّ حقيقي وراءهما، وأي
                زائر يسأل «أين الـ 412 تقييماً؟» يفقد الثقة بكل ما عداهما */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-x-3 gap-y-2 mb-4 text-sm">
              <span className="flex items-center gap-2 text-z-gray">
                <i className="fa-solid fa-user-check text-z-green" />
                +{PRODUCT.customersCount} {content.customersLine}
              </span>
            </div>

            <div className="flex flex-wrap items-end justify-center lg:justify-start gap-x-4 gap-y-2 mb-5">
              <div className="text-start">
                <span className="block text-xs md:text-sm text-z-gray font-semibold mb-1">
                  {content.heroPriceLabel}
                </span>
                <span className="text-4xl md:text-5xl font-bold text-z-navy">{formatPrice(PRODUCT.price)}</span>
              </div>
              {/* السعر المشطوب وشارة التوفير يظهران فقط إن كان هناك توفير فعلاً.
                  لو صار السعر القديم أقل من الحالي لأي سبب، عرضهما يكشف تناقضاً
                  ويطبع رقماً سالباً — والصمت أفضل من رقم يهدم الثقة */}
              {saving > 0 && (
                <>
                  <span className="text-lg md:text-2xl text-z-gray line-through pb-1">
                    {formatPrice(PRODUCT.oldPrice)}
                  </span>
                  <span className="bg-z-red text-white text-xs md:text-sm font-bold px-4 py-2 rounded-full mb-1">
                    {content.heroSaveLabel} {formatPrice(saving)}
                  </span>
                </>
              )}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <Link
                to={orderPath()}
                className="w-full sm:w-auto bg-z-red text-white px-8 py-4 font-bold text-base xl:text-lg hover:bg-z-red/90 rounded-full transition-all flex items-center justify-center gap-3 shadow-lg shadow-z-red/30"
              >
                {content.btnBuyNow} <i className="fa-solid fa-bag-shopping text-xl" />
              </Link>

              {/* على الجوال رابط مضغوط بدل زر عريض — يوفّر سطراً كاملاً من الشاشة الأولى */}
              <a
                href="#how"
                className="text-z-navy font-bold text-sm flex items-center gap-2 py-1 sm:border-2 sm:border-z-navy sm:px-8 sm:py-4 sm:text-base xl:text-lg sm:rounded-full sm:hover:bg-z-navy sm:hover:text-white transition-colors"
              >
                <i className="fa-solid fa-circle-play" /> {content.btnLearnMore}
              </a>
            </div>
          </div>

          {/* ===== شريط المواصفات ===== */}
          <div className="lg:col-start-1 lg:row-start-2 lg:self-start">
            <div className="grid grid-cols-4 gap-2 md:gap-3 max-w-xl mx-auto lg:mx-0">
              {content.heroSpecs.map((spec) => (
                <div
                  key={spec.label}
                  className="bg-z-light border border-gray-200 rounded-2xl py-3 px-1 flex flex-col items-center justify-center text-center"
                >
                  <i className={`fa-solid ${spec.icon} text-z-red text-sm md:text-base mb-1`} />
                  <span className="block text-base md:text-xl font-bold text-z-navy leading-none">{spec.value}</span>
                  <span className="block text-[10px] md:text-xs text-z-gray mt-1 leading-tight">{spec.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
